import { getBag } from './reference-bags';

export const getInternalIdFromApiCode = (apiCode, providerType) => {
  const { collection, cacheReferenceKey } = getBag(providerType);
  const reference = collection?.find((p) => p.apiCode === apiCode);

  return reference?.[cacheReferenceKey];
};
